<script setup>
import { computed, watch } from "vue";
import { useRouter } from "vue-router";

import BaseText from "@/library/BaseText.vue";
import BaseIcon from "@/library/BaseIcon.vue";

import store from "@/store";
import { useBasicMode } from "@/composables/useBasicMode.js";

const router = useRouter();
const { isBasicModeAccessible, isBasicModeEnabled } = useBasicMode();

const userLoaded = computed(() => !!store.state.authentication?.user);

const hasForYou = computed(
  () => store.state.authentication?.user?.flags?.feature_discover_tab
);

const basicModeEnabled = computed(
  () => isBasicModeAccessible.value && isBasicModeEnabled.value
);

watch(
  [userLoaded, hasForYou, basicModeEnabled],
  ([loaded, hasFeature, isBasicMode]) => {
    if (loaded && (!hasFeature || !isBasicMode)) {
      router.push("/");
    }
  },
  { immediate: true }
);
</script>

<template>
  <div class="page-for-you">
    <div class="page-for-you__content">
      <div class="page-for-you__header">
        <BaseIcon
          name="bolt"
          class="page-for-you__header-icon"
        />
        <BaseText
          as="h1"
          variant="headline-3-medium"
          class="page-for-you__header-title"
        >
          Discover new kinds of protection
        </BaseText>
        <BaseText
          as="h2"
          variant="headline-6-medium"
          class="page-for-you__header-subtitle"
        >
          Included with your subscription
        </BaseText>
      </div>

      <div class="page-for-you__coming-soon">
        <BaseText
          as="h3"
          variant="headline-6-medium"
        >
          Coming soon...
        </BaseText>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-for-you {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding-right: 8px;
  padding-bottom: 8px;

  &__content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background-color: $color-primary-5;
    border-radius: 20px;
    padding: 24px;
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    &-icon {
      display: block;
      width: 32px;
      height: 32px;
      font-size: 32px;
      font-weight: 500;
    }

    &-subtitle {
      color: $color-primary-70;
    }
  }

  &__coming-soon {
    margin-top: 24px;
  }
}
</style>
